import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import { SLOW_TIMER } from '~/const/timers';
var VueSlider = {};

if (process.browser) {
  // eslint-disable-next-line
  VueSlider = require('vue-slider-component');
}

export default {
  name: 'CategoryDimensionsFilter',
  components: {
    VueSlider: VueSlider
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    desktopLayer: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      model: {
        depth: this.getInitialDimensionValue('depth'),
        width: this.getInitialDimensionValue('width'),
        height: this.getInitialDimensionValue('height'),
        timer: null
      }
    };
  },
  computed: {
    tracking: function tracking() {
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: 'Filtre_Taille',
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    }
  },
  watch: {
    filter: function filter() {
      this.model = {
        depth: this.getInitialDimensionValue('depth'),
        width: this.getInitialDimensionValue('width'),
        height: this.getInitialDimensionValue('height')
      };
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    filterBy: 'pageActions/FILTER_BY'
  })), {}, {
    handleInputInstantly: function handleInputInstantly(facet, value) {
      var _this = this;

      if (value && this.model && (facet || {}).dimension) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }

        var facetDimension = parseInt(value, 10);
        this.model[facet.dimension] = facetDimension;
        var minFacet = this.minFacet(facet.min);
        var maxfacet = parseFloat(parseFloat(facet.max, 10).toFixed(2), 10);

        if ([minFacet, maxfacet].indexOf(facetDimension) !== -1) {
          this.timer = setTimeout(function () {
            _this.handleInput(facet, value);
          }, SLOW_TIMER);
        }
      }
    },
    handleInput: function handleInput(facet, event) {
      if (!this.model[facet.dimension]) {
        return;
      }

      this.filterBy({
        filter: facet.dimension,
        facet: "0-".concat(parseInt(this.model[facet.dimension], 10)),
        uniq: true
      });
      this.$root.$emit('generic-tracking', event, this.tracking);
    },
    generateSilderOptions: function generateSilderOptions(facet) {
      return {
        height: 2,
        silent: true,
        enableCross: false,
        dotSize: 25,
        min: this.minFacet(facet.min),
        max: parseFloat(parseFloat(facet.max, 10).toFixed(2), 10),
        interval: 0.01,
        lazy: true,
        tooltip: 'none',
        processStyle: {
          backgroundColor: '#c4a181'
        },
        railStyle: {
          backgroundColor: '#9B9B9B'
        }
      };
    },
    dotText: function dotText(dimension) {
      return this.model[dimension] ? parseInt(this.model[dimension], 10) : '';
    },
    minFacet: function minFacet(min) {
      return parseFloat(parseFloat(min, 10).toFixed(2), 10) < 1 ? 1.00 : parseFloat(parseFloat(min, 10).toFixed(2), 10);
    },
    getInitialDimensionValue: function getInitialDimensionValue(dimension) {
      var selectedValue;
      var defaultValue;

      switch (dimension) {
        case 'depth':
          selectedValue = this.filter.facets[0].selected ? parseFloat(this.filter.facets[0].selected.max, 10) : null;
          defaultValue = parseFloat(this.filter.facets[0].max, 10);
          return selectedValue && selectedValue < defaultValue ? selectedValue : defaultValue;

        case 'width':
          selectedValue = this.filter.facets[1].selected ? parseFloat(this.filter.facets[1].selected.max, 10) : null;
          defaultValue = parseFloat(this.filter.facets[1].max, 10);
          return selectedValue && selectedValue < defaultValue ? selectedValue : defaultValue;

        case 'height':
          selectedValue = this.filter.facets[2].selected ? parseFloat(this.filter.facets[2].selected.max, 10) : null;
          defaultValue = parseFloat(this.filter.facets[2].max, 10);
          return selectedValue && selectedValue < defaultValue ? selectedValue : defaultValue;

        default:
          return 0;
      }
    }
  })
};